import { handleActions } from 'redux-actions';
import flow from 'lodash/fp/flow';
import range from 'lodash/range';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import sortBy from 'lodash/sortBy';
import flatMap from 'lodash/fp/flatMap';
import _ from "lodash"
import { removeEmptyObjects } from '../../../shared/helpers';
import { initialState as onboardingState } from '../Onboarding';

export const initialState = {
  project: {},
  managers: [],
  freelancers: [],
  pageState: {
    editReferences: false,
  },
  formInfo: {},
};

export const BID_REQUEST_EXPIRATION_TIME = 24;

const getCardList = () => {
  const {
    basic_information: basic,
    additional_requirements: additional,
    project_materials: materials,
    submit,
  } = onboardingState;

  const steps = [basic, additional, materials, submit];

  return flow(
    flatMap(i => i.onboardingSteps),
    flatMap(i => i.cards),
  )(steps);
};

export const cardList = getCardList();

const projectView = handleActions(
  {
    SET_PROJECT: (state, action) => {
      const { project } = action.payload;

      const onboardingInfo = project.project_onboarding_infos.map(info => {
        const response = info.question_response.map(value =>
          cardList.find(card => card.value === value),
        );

        return { ...info, card: removeEmptyObjects(response) };
      });

      const getResponce = key => {
        const response = onboardingInfo.find(info => info.question.key === key);
        return response.question_response;
      };

      const drafts = mapDrafts(project);

      const additionalRequirements = {
        deadline: getResponce('deadline') && getResponce('deadline')[0],
        tone: getResponce('tone') && getResponce('tone')[0],
        series: getResponce('series'),
        files: getResponce('files'),
        dropbox_urls: project.dropbox_urls,
        script: getResponce('script'),
        storyboard: getResponce('storyboard'),
        soundtrack: getResponce('soundtrack'),
        stock_footage: getResponce('stock_footage'),
        voiceover: getResponce('voiceover'),
        format: getResponce('format') && getResponce('format')[0],
        audience: getResponce('audience'),
        project_requirements: getResponce('project_requirements'),
        video_layout: getResponce('video_layout'),
      };

      return {
        ...state,
        project: {
          ...project,
          drafts,
          adds: additionalRequirements,
          project_onboarding_infos: onboardingInfo,
        },
        pageState: {
          editReferences: false,
        },
        formInfo: {
          projectName: project.project_name,
          comments: project.comment,
          references: _.cloneDeep(project.references),
          projectPicture: project.project_picture,
          answered_questions: _.cloneDeep(additionalRequirements),
          dropbox_urls: project.dropbox_urls,
        },
      };
    },
    SET_PROJECT_FREELANCERS: (state, action) => {
      const { freelancers } = action.payload;

      const bids = get(state.project, 'bids', []).map(bid => {
        const freelancer = freelancers.find(
          freela => freela.id === bid.freelancer_id,
        );
        return { ...bid, freelancer };
      });

      return {
        ...state,
        project: {
          ...state.project,
          bids,
        },
      };
    },
    SET_MANAGERS: (state, { payload: { managers } }) => ({
      ...state,
      managers: mapUsersToDropdownOptions(managers),
    }),
    SET_FREELANCERS: (state, { payload: { freelancers } }) => ({
      ...state,
      freelancers: mapUsersToDropdownOptions(freelancers),
    }),
    AUTHENTICATION_LOGOUT: () => ({
      ...initialState,
    }),
    CHANGE_PAGE_STATE: (state, { payload: { newPageState } }) => ({
      ...state,
      pageState: newPageState,
    }),
    SAVE_PROJECT_FORM_INFO: (state, action) => ({
      ...state,
      formInfo: { ...state.formInfo, ...action.payload.value },
    }),
  },
  initialState,
);

const mapUsersToDropdownOptions = users =>
  users.map(user => ({
    key: user.id,
    text: user.name,
    value: user.id,
    image: { avatar: true, src: user.avatar_url },
  }));

const mapDrafts = project => {
  if (!isEmpty(project.drafts)) return sortBy(project.drafts, a => a.name);

  const draftsList = range(1, 5).map(i => ({
    ...get(project, `drafts[${i - 1}]`, {}),
    name: `draft_${i}`,
    index: i - 1,
  }));

  const ds = draftsList.map((draft, index) => {
    const prevDraft = draftsList[index - 1];

    if (project.status !== 'pending' && project.freelancer) {
      if (!prevDraft) {
        if (draft.url) {
          return { ...draft, status: 'submitted' };
        }
        if (draft.due_date) {
          return { ...draft, status: 'due_in' };
        }

        return { ...draft, status: 'in_progress' };
      }
    }

    return { ...draft, status: 'not_started' };
  });

  return ds;
};

export default projectView;



// WEBPACK FOOTER //
// ./src/store/reducers/ProjectView/index.js